
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["loadCenterline"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "centerline.4ee5785d.worker.js", { name: "centerline.[contenthash:8].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			